import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 transition-all duration-300 hover:border-primary-200 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.coverImage}
          alt={movie.title}
          title={`${movie.title} - 哈哈影院高清免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {movie.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-background-50 whitespace-nowrap">新</span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-50 whitespace-nowrap">热播</span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs font-bold rounded bg-background-950/70 text-accent-400 whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-xs text-background-50 line-clamp-2">{movie.description}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-foreground-900 text-sm leading-tight line-clamp-1 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{movie.region}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {movie.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}